import {
  UPLOAD_ACCEPTED_FILE_TYPES_IMAGES,
  UPLOAD_ACCEPTED_FILE_TYPES_DOCUMENTS,
} from "~/data/const"
import { usePage } from "~/hooks/usePage"

export const useAcceptedFiles = () => {
  const { page } = usePage()
  const { isADocumentPrintingPage } = page

  let acceptedFileTypes = UPLOAD_ACCEPTED_FILE_TYPES_IMAGES
  if (isADocumentPrintingPage) {
    acceptedFileTypes = UPLOAD_ACCEPTED_FILE_TYPES_DOCUMENTS
  }

  return acceptedFileTypes
}
